import ConsulDirectory from '../../api/http/consulDirectory';

const settings = {
  namespaced: true,
  state() {
    return {
      office: [],
      isUpdating: false,
    };
  },
  getters: {
    office: state => state.office,
    isUpdating: state => state.isUpdating,
  },
  mutations: {
    setOffice(state, value) {
      state.office = value;
    },
    setIsUpdating(state, value) {
      state.isUpdating = value;
    },
  },
  actions: {
    getSettings({ commit }) {
      return ConsulDirectory.settings().then(({ data }) => {
        const { office, isUpdating } = data;

        commit('setOffice', office);
        commit('setIsUpdating', isUpdating);
      });
    },
  },
};

export default settings;
